<p-panel>
    <app-reactive-form-builder
        (goBack)="goBack()"
        [form]="form.formFields"
        [id]="getModel().id ?? ''"
        [request]="this.getType() === 1 ? this.productosApi.productos.PUT : this.productosApi.productos.POST"
        [getRequest]="productosApi.productos.GET">
    </app-reactive-form-builder>
</p-panel>
<br>
